import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-420c0ba0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex bg-white align-items-center pl-3 sticky-top shadow" }
const _hoisted_2 = { class: "h-100 d-flex align-items-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "bg-gray" }
const _hoisted_5 = { class: "d-flex flex-column-reverse flex-lg-row align-items-center justify-content-center justify-content-lg-between px-md-5" }
const _hoisted_6 = { class: "fs-8" }
const _hoisted_7 = { class: "d-flex align-items-center justify-content-between mb-2 mb-lg-0" }
const _hoisted_8 = ["href"]

import { ref } from 'vue'
import { URL_PRIVACY, URL_COMPANY } from '@/constants/common'
import { translate } from '@/languages/i18n'

type FooterLink = {
  id: number
  title: string
  to: string
  dataBsTarget: any
  dataBsToggle: any
  onClick: any
}

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const menu: ref<Array<FooterLink>> = [
  {
    id: 2,
    title: translate('privacy'),
    to: URL_PRIVACY,
  },
  {
    id: 3,
    title: translate('company'),
    to: URL_COMPANY,
  },
]

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          src: require('@/assets/images/YELLoop_logo_slogan.svg'),
          alt: "logo",
          id: "logo2"
        }, null, 8, _hoisted_3)
      ])
    ]),
    _createElementVNode("section", _hoisted_4, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _createElementVNode("footer", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(translate)('copyRight')), 1),
      _createElementVNode("ul", _hoisted_7, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(menu, (item) => {
          return _createElementVNode("li", {
            key: item.id
          }, [
            _createElementVNode("a", {
              href: item.to,
              class: "text-black text-decoration-none fs-8",
              target: "_blank"
            }, _toDisplayString(item.title), 9, _hoisted_8)
          ])
        }), 64))
      ])
    ])
  ], 64))
}
}

})